/**
 * EE「资源管理」菜单：从 CE containers 各模块 router 组装，再叠加 EE-only 菜单。
 * 新增通用菜单请改 dashboard/containers 对应 router，此处会自动带上。
 */
import store from '@/store'
import i18n from '@/locales'

import Cloudenv from '@Cloudenv/router'
import Compute from '@Compute/router'
import Network from '@Network/router'
import Storage from '@Storage/router'
import K8S from '@K8S/router'
import DB from '@DB/router'
import Middleware from '@Middleware/router'
import Application from '@Application/router'
import Ai from '@Ai/router'

import {
  attachGroup,
  composeFromModules,
  insertSubmenuAfter,
  mergeByComposeGroup,
} from '@generalScope/utils/composeMenus'
import {
  topologySubmenu,
  modelartsMenu,
  aiGatewaySubmenu,
  mcpMenu,
  customDataMenu,
} from '@generalScope/eeMenus/resourceExtras'

const hideOnSysCE = (menu) => {
  const prevHidden = menu.meta && menu.meta.hidden
  return {
    ...menu,
    meta: {
      ...(menu.meta || {}),
      hidden: (userInfo, m) => {
        if (store.getters.isSysCE) return true
        if (typeof prevHidden === 'function') {
          return prevHidden(userInfo, m)
        }
        return false
      },
    },
  }
}

const cloudaccountMenus = attachGroup(Cloudenv.menus, {
  group: 'resource',
  subGroup: 'cloudaccount',
  mapMenu: (menu) => ({
    ...menu,
    meta: {
      ...(menu.meta || {}),
      label: i18n.t('cloudenv.text_8'),
    },
  }),
})

const serverMenus = attachGroup(
  mergeByComposeGroup(Compute.menus),
  {
    group: 'resource',
    subGroup: 'server',
  },
)

const networkMenus = insertSubmenuAfter(
  attachGroup(mergeByComposeGroup(Network.menus), {
    group: 'resource',
    subGroup: 'network',
  }),
  '/zone',
  topologySubmenu,
)

const storageMenus = attachGroup(Storage.menus, {
  group: 'resource',
  subGroup: 'storage',
})

const k8sMenus = attachGroup(K8S.menus, {
  group: 'resource',
  subGroup: 'k8s',
})

const middlewareMenus = composeFromModules([
  { menus: DB.menus, group: 'resource', subGroup: 'middleware' },
  { menus: Middleware.menus, group: 'resource', subGroup: 'middleware' },
])

const applicationMenus = attachGroup(Application.menus, {
  group: 'resource',
  subGroup: 'application',
})

const aiMenus = [
  modelartsMenu,
  ...insertSubmenuAfter(
    attachGroup(Ai.menus, {
      group: 'resource',
      subGroup: 'ai',
      mapMenu: hideOnSysCE,
    }),
    '/ai-proxy-node',
    aiGatewaySubmenu,
  ),
  mcpMenu,
]

export default {
  index: 20,
  meta: {
    label: i18n.t('dictionary.menu_resource_management'),
    t: 'dictionary.menu_resource_management',
    icon: 'resource-manage',
  },
  menus: [
    ...cloudaccountMenus,
    ...serverMenus,
    ...networkMenus,
    ...storageMenus,
    ...k8sMenus,
    ...middlewareMenus,
    ...applicationMenus,
    ...aiMenus,
    customDataMenu,
  ],
}
